import React from "react";

function OrderSummary() {
  return (
    <div className="min-h-screenflex items-center justify-center">
      <div className="bg-white w-full max-w-2xl p-6 relative">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-lg font-semibold">Hotel Booking Order Summary</h2>
          <div className="flex flex-col items-center cursor-pointer">
            <i class="fa-solid fa-download"></i>
            <span className="text-xs">pdf</span>
          </div>
        </div>

        <div className="bg-gray-200 p-6 rounded-xl space-y-6">
          <div>
            <h3 className="font-semibold text-md mb-2">Guest Information</h3>
            <div className="space-y-1">
              <p>
                <i class="fa-solid fa-user"></i>{" "}
                <span className="font-medium">Name:</span> John Doe
              </p>
              <p>
                <i class="fa-solid fa-envelope"></i>{" "}
                <span className="font-medium">Email:</span> john.doe@example.com
              </p>
              <p>
                <i class="fa-solid fa-phone"></i>{" "}
                <span className="font-medium">Phone:</span> +1 234 567 8900
              </p>
            </div>
          </div>

          {/* Booking Details */}
          <div>
            <h3 className="font-semibold text-md mb-2">Booking Details</h3>
            <ul className="list-disc list-inside space-y-1 text-sm">
              <li>
                <span className="font-semibold">Hotel Name:</span> Grand Royal
                Hotel
              </li>
              <li>
                <span className="font-semibold">Room Type:</span> Deluxe King
                Room
              </li>
              <li>
                <span className="font-semibold">Number of Guests:</span> 2
                Adults
              </li>
              <li>
                <span className="font-semibold">Check-in Date:</span> May 25,
                2025
              </li>
              <li>
                <span className="font-semibold">Check-out Date:</span> May 28,
                2025
              </li>
              <li>
                <span className="font-semibold">Nights:</span> 3
              </li>
              <li>
                <span className="font-semibold">Booking Reference:</span>{" "}
                GRH-2025-0518-XYZ123
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-semibold text-md mb-2">Payment Summary</h3>
            <div className="text-sm space-y-2">
              <div className="flex justify-between font-semibold">
                <span>Item Price</span>
                <span>$9.00</span>
              </div>
              <div className="flex justify-between">
                <span>Discount Price</span>
                <span>$0.00</span>
              </div>
              <div className="flex justify-between">
                <span>Tax</span>
                <span>$0.87</span>
              </div>
              <div className="flex justify-between">
                <span>Coupon</span>
                <span>XSFSA42</span>
              </div>
              <hr className="my-2 border-black" />
              <div className="flex justify-between text-lg font-semibold">
                <span>Total :</span>
                <span>$9.87</span>
              </div>
            </div>
          </div>
        </div>

        {/* Confirm Button */}
        <div className="mt-6">
          <button className="w-full border border-black py-2 rounded-xl text-lg font-medium hover:bg-black hover:text-white transition">
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
}

export default OrderSummary;
